module.exports = __webpack_public_path__ + "static/media/balls.9cf89488.png";